module.exports = __webpack_public_path__ + "img/sticker.e22e3ce9.svg";